import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { QueryKey } from '@/Config/api/queryKey';
import { KnowledgeBase } from '@/Domain/api/KnowledgeBase/dto/KnowledgeBase.dto';
import { ReadDocumentationButton } from '@/Domain/components/Integration/components/ReadDocumentationButton';
import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { AiModelData } from '@/UI/Identity/AiModel/aiModel.constants';
import { AISettings } from '@/UI/Identity/Identity.constants';
import { IdentityContent } from '@/UI/Identity/components/IdentityContent';

export const IdentityPage = () => {
  const { t } = useTranslation('identity');

  const settings = useQuery<AISettings>({ queryKey: ['settings'] });
  const knowledgeBase = useQuery<KnowledgeBase>({ queryKey: ['knowledge_base'] });
  const model = useQuery<AiModelData>({ queryKey: [QueryKey.aiModel.get] });

  const isReady = settings.data && knowledgeBase.data;

  return (
    <div className="mx-auto w-full max-w-7xl">
      <div className="mb-6 flex items-center justify-between gap-4">
        <h1 className="text-lg font-semibold text-foreground">{t('title')}</h1>
        <ReadDocumentationButton href="https://docs.quickchat.ai/ai-agent/identity" />
      </div>

      {isReady ? (
        <IdentityContent
          settings={settings.data as AISettings}
          knowledgeBase={knowledgeBase.data as KnowledgeBase}
          model={model.data}
        />
      ) : (
        <CenterSpinner />
      )}
    </div>
  );
};
